import {
    DetailOrderHeader,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DossierDocumentsProvider,
    OrderDuplicateForm,
    useCurrentCollectionCtx,
} from '@europrocurement/l2d-modules';
import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import {
    selectedPrescripteursSelector,
    useTiersService,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import { ParcoursFormaliteProvider } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { AnyAction } from '@reduxjs/toolkit';
import { useAppDispatch } from '../../../../redux/types';

const OrderDuplicate: React.FunctionComponent = function () {
    const dispatch = useAppDispatch();
    const { collection } = useCurrentCollectionCtx();
    const { selectPrescripteur, selectSousClients } = useTiersService();
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);
    const { getSousClients, getPrescripteurs } = useTiersService();

    const [idsDossiers, setIdsDossiers] = useState<number[]>([]);
    const [hasDispatchPrescriber, setHasDispatchPrescriber] = useState(false);

    useEffect(() => {
        dispatch(getSousClients({}) as unknown as AnyAction);
        dispatch(getPrescripteurs({}) as unknown as AnyAction);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (collection && collection.id) {
            // Extract all dossiers ids related to the collection, to provide ids to the DossierDocumentsProvider
            const idDossiers = collection?.dossiers
                ? collection.dossiers
                      .map((dossier) => dossier.id)
                      .filter((id): id is number => id !== undefined)
                : [];

            setIdsDossiers(idDossiers);

            if (collection?.clientId) {
                dispatch(selectSousClients({ id: collection.clientId }));
            }
        }
    }, [dispatch, collection, selectPrescripteur, selectSousClients]);

    // Dispatch order prescriber
    useEffect(() => {
        if (collection && collection.prescripteurId) {
            if (!prescripteur || prescripteur.id !== collection.prescripteurId) {
                dispatch(selectPrescripteur({ id: collection.prescripteurId }));
                dispatch({
                    type: 'sousClient/setmainFilter',
                    payload: {
                        key: 'prescripteurId',
                        value: collection.prescripteurId,
                    },
                });
                setHasDispatchPrescriber(true);
            } else {
                setHasDispatchPrescriber(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prescripteur, collection, selectPrescripteur]);

    return (
        <DossierDocumentsProvider
            autoload
            dossierIds={idsDossiers}
        >
            {hasDispatchPrescriber && prescripteur && collection && collection.dossiers && (
                <ParcoursFormaliteProvider
                    prescripteur={prescripteur}
                    back
                >
                    <DocumentPreviewProvider>
                        <Container maxWidth="lg">
                            <DetailOrderHeader displayDetailOrder={false} />
                            <OrderDuplicateForm
                                dossiers={collection.dossiers}
                                collection={collection}
                            />
                            <DocumentPreviewOverlay />
                        </Container>
                    </DocumentPreviewProvider>
                </ParcoursFormaliteProvider>
            )}
        </DossierDocumentsProvider>
    );
};

export default OrderDuplicate;
